var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretcircledoubleright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.684 8.434a.8.8 0 011.132 0l3 3a.8.8 0 010 1.132l-3 3a.8.8 0 01-1.132-1.132L10.12 12 7.684 9.566a.8.8 0 010-1.132zM14.066 8.434a.8.8 0 00-1.132 1.132L15.37 12l-2.435 2.434a.8.8 0 001.132 1.132l3-3a.8.8 0 000-1.132z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.2 12c0-5.412 4.388-9.8 9.8-9.8 5.412 0 9.8 4.388 9.8 9.8 0 5.412-4.388 9.8-9.8 9.8-5.412 0-9.8-4.388-9.8-9.8zM12 3.8a8.2 8.2 0 100 16.4 8.2 8.2 0 000-16.4z",
    fillRule: "evenodd"
  }))));
}

export default SvgCaretcircledoubleright;